import{__exports as o}from"../../../_virtual/object-get-own-property-symbols.js";import{__exports as p}from"../../../_virtual/object-get-own-property-symbols.js";o.f=Object.getOwnPropertySymbols;export{p as default};
